(function () {
    'use strict';

    angular
        .module('ib-bob-module')
        .directive('deleteTooltip', deleteTooltip);

    deleteTooltip.$inject = ['$window'];
    function deleteTooltip ($window) {
        // Usage:
        //
        // Creates:
        //
        return {
            link: link,
            restrict: 'A'
        };

        function link (scope, element, attrs) {
            angular.element(element).mouseout(() => {
                if (angular.element('#tooltipHover').length > 0) {
                    angular.element('#tooltipHover').remove();
                }
            });

            angular.element('.modal-content').click((e) => {
                if (!(angular.element(e.target).hasClass('ib-add-bag-tooltip-touch__button') || angular.element(e.target).hasClass('ib-add-bags__button') || angular.element(e.target).hasClass('ib-add-bags__button--remove'))) {
                    if (angular.element('#toolTipTouch').length > 0) {
                        angular.element('#toolTipTouch').remove();
                    }
                }
            });
        }
    }
})();
